<template>
    <div class="yq-es-query-group">
        <div class="yq-es-query-group-item" v-for="(item,index) in cachedValue.children" :key="index">
            <es-query-field v-if="item.type==='field'" :data-source="dataSource"
                            v-model="cachedValue.children[index]"></es-query-field>
            <es-query-group v-else-if="item.type==='group'" :data-source="dataSource"
                            v-model="cachedValue.children[index]"></es-query-group>
            <el-link @click="cachedValue.children.splice(index, 1)">删除</el-link>
        </div>
        <div class="yq-es-query-group-input-field">
            <es-query-field :data-source="dataSource" v-model="inputField"></es-query-field>
            <el-link @click="addField">添加</el-link>
        </div>
        <div class="yq-es-query-group-config">
            <div class="yq-es-query-group-config-label">字段间关系：</div>
            <el-radio v-model="cachedValue.logic" label="and">与</el-radio>
            <el-radio v-model="cachedValue.logic" label="or">或</el-radio>
            <el-link @click="addGroup">添加分组</el-link>
        </div>
    </div>
</template>

<script>
    import EsQueryField from "./EsQueryField";

    export default {
        name: "EsQueryGroup",
        components: {EsQueryField},
        props: ['value', 'dataSource'],
        data() {
            return {
                cachedValue: JSON.parse(JSON.stringify(this.value)),
                inputField: {
                    type: 'field',
                    field: null,
                    op: null,
                    value: null
                }
            }
        },
        watch: {
            'value': {
                deep: true,
                handler: function (val) {
                    if (this.isSameQuery(val, this.cachedValue)) {
                        return
                    }
                    this.cachedValue = JSON.parse(JSON.stringify(val))
                }
            },
            'cachedValue': {
                deep: true,
                handler: function (val) {
                    this.$emit('input', JSON.parse(JSON.stringify(val)))
                }
            }
        },
        methods: {
            isSameQuery(q1, q2) {
                if (q1.type !== q2.type) {
                    return false
                }
                if (q1.type === 'group') {
                    if (q1.logic !== q2.logic || q1.children.length !== q2.children.length) {
                        return false
                    }
                    for (let i = 0; i < q1.children.length; i++) {
                        if (!this.isSameQuery(q1.children[i], q2.children[i])) {
                            return false
                        }
                    }
                    return true
                } else {
                    return q1.field === q2.field && q1.op === q2.op && q1.value === q2.value
                }
            },
            addField() {
                this.cachedValue.children.push(JSON.parse(JSON.stringify(this.inputField)))
                this.inputField = {
                    type: 'field',
                    field: null,
                    op: null,
                    value: null
                }
            },
            addGroup() {
                this.cachedValue.children.push({
                    type: "group",
                    logic: "and",
                    children: []
                })
            }
        }
    }
</script>

<style scoped>
    .yq-es-query-group-config {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .yq-es-query-group-config-label {
        font-size: 14px;
        color: #606266;
    }

    .yq-es-query-group-item {
        display: flex;
        align-items: center;
    }

    .yq-es-query-group-item+.yq-es-query-group-item{
        margin-top: 5px;
    }

    .yq-es-query-group-item > .yq-es-query-field{
        flex: auto;
    }

    .yq-es-query-group-item > .yq-es-query-group {
        margin-left: 20px;
        border: 1px solid #2A9CFF;
        padding: 5px;
        flex: auto;
    }

    .yq-es-query-group-item > .el-link {
        flex: none;
        margin-left: 10px;
    }

    .yq-es-query-group-input-field{
        display: flex;
        align-items: center;
        margin-top: 5px;
    }

    .yq-es-query-group-input-field > .yq-es-query-field{
        flex: auto;
    }

    .yq-es-query-group-input-field > .el-link {
        flex: none;
        margin-left: 10px;
    }

    .yq-es-query-group-config{
        margin-top: 5px;
    }
</style>
